module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("PLEASE READ BEFORE READING THIS BOOK")]), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("NOTE FROM AUTHOR")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Disclaimers")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Although Bad Boy Royals of Kingsbury Prep is fiction, there was a school in history that only allowed those of royal blood to attend. It was a school to train them to become global rulers and diplomats. "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("The names of the countries of the royals have been changed for fictional purposes.")]), _vm._v(" In the writing of this series, specialists such as a weapons specialist, a fighting specialist, and a lawyer were consulted to best accurately depict certain scenes, while being fiction. "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("While this takes place at a high school level academy, due to the maturity of the themes, language, and sexual content; this series is best suitable for a mature audience. Tempest and her lovers are seniors and at least 18 years old.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("This is also a Reverse Harem, which means the main female character will have three or more love interests. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Possible triggers in this book for those sensitive to these issues: suicide, bullying, attempted rape.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("The entire series for Bad Boy Royals of Kingsbury Prep takes place during Senior Year for Tempest and the K3s. Events may go faster than a typical bully romance RH Academy book, which takes place 1 book per year. Tempest, Book 1, is told from her point-of-view and the language will reflect this. The structure of events and timing will reflect her point-of-view to keep with the integrity of the storytelling. Please keep an open mind for the way this book is told, as it may not fall within the typical style of RH Romances and Bully Romances. Contrary to typical RH Romances and Bully Romances, this series has a twist to it.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("As this book series has been optioned as a film and is based on a mix between genres (manga, mature comic, and contemporary romance), there will be more action rather than description. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Finally, this is a bully romance which means enemy to lover romance. By no means do we promote or advocate any bullying of any kind, but seek to prevent it in real life. If anyone is facing bullying in real life, there are resources and help out there. One we recommend is: ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-decoration": "underline",
      "text-indent": "0"
    }
  }, [_vm._v("Shy Girls Social Club Handbook on Dealing with Bullies and Other Meanies by Kailin Gow")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-decoration": "underline",
      "text-indent": "0"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.amazon.com/Social-Handbook-Dealing-Bullies-Meanies-ebook/dp/B0049B2C7A",
      "target": "_blank"
    }
  }, [_vm._v("https://www.amazon.com/Social-Handbook-Dealing-Bullies-Meanies-ebook/dp/B0049B2C7A")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Tempest")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("San Francisco")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene with-quote character-s"
  }, [_vm._v("“S")]), _vm._v("O, AUNTIE,” JORDAN")]), _vm._v(" said, “How do you like my dream girl? Isn’t she everything a man could want?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Helen laughed. “She’s like a granddaughter to me. I already know Tempest.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I helped Lily send Tempest to Kingsbury Prep to get all this rolling.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I don’t get it,” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“To meet Kaz, my knucklehead great-nephew.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Why?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“He needs to be shaken up, and by a girl who would rock his world so much it would change him.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But he’s still the same,” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, he isn’t,” Helen said. “He won’t be. Not with this announcement.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What announcement?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Helen looked to Jordan, and he turned to me to take my hand in his. “I owe you a lot for this, Tempest, because it showed my father who to choose. You’re with me now, and not with Kaz because of his stupidity and immaturity. You’re still the Kingmaker, Tempest, as I said. My parents had always placed a lot of trust into the visions of the Kingmaker so, my father made this announcement today. When he retires, he will pass the crown and duties of the King to me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My mouth fell open.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I am now the Crown Prince who will become King someday,” Jordan said, gazing into my eyes. “And I couldn’t think of anyone I wanted to share the news to first than you, Tempest and you Aunt Helen.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He leaned in to kiss me, as Helen watched. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m going to marry this girl someday,” Jordan said to Helen. “If she’ll have me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I liked Jordan, but I wasn’t quite in love with him since I was just getting to know him. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But Kaz...my heart was breaking for him. He not only lost me, but he just lost his inheritance, his status, and his kingdom.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Tempest")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")]), _vm._v(" TURNED TO JORDAN")]), _vm._v(" and said, “I don’t feel well.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("His smile disappeared as a look of concern crossed his face, and he immediately brought the back of his hand to my forehead to feel for temperature. He then placed his palm against my cheeks. “You’re a little warm.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Helen immediately took over. “Oh Tempest, I missed my girl. How about some nice chicken noodle soup from Helen’s Kitchen?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Helen’s Kitchen?” I asked. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Helen blushed and said, “I was going to tell you once you got back to San Francisco. I opened a small stall at one of the shops along the Wharf. I sell my baked goods and soups there. It keeps me busy, and I’m making a decent living from it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jordan turned to Helen, “That’s very enterprising of you, Aunt Helen, but you’re a princess. You’ll be surrounded by luxury and waited on by everyone if you came back to the palace.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Helen shook her head. “I’d rather live in my trailer than return to that gilded cage you call a palace.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“When I become King,” Jordan said, “I’ll change that. I’ll change a lot of things.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Like what?” I asked. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I have a few things planned,” Jordan said, smiling as he brought his fingers up to touch my face. “For starters, I’d bring you back with me. And Aunt Helen.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I love it here, Jordan,” Helen said. “I’m not about to give up my life here to go back. Plus, I have a boyfriend.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My mouth dropped. “You have a boyfriend?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Helen looked coy. “You know...your lawyer, Frank.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You’re finally dating,” I said laughing. “Wait until Lily hears this!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, Lily knows already. She knew for a while. We just didn’t tell you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I turned to Jordan. “Speaking of Lily, I need to see her.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But Baby,” Jordan said. “You have a bit of a temperature. Why don’t we take you back to my place, and let me take care of you?” He pulled me to him and kissed my forehead. He turned to Helen and said, “We’ll have to have lunch or dinner with you another time. I’ll take Tempest back to my place and later I’ll swing by for your soup.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Promise?” Helen asked. “Or I could take care of her. I’ve been taking care of her and watching over her for years, you know. She’s family so take very good care of my Tempest.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jordan took both of Helen’s hands and looked her in the eyes, “I promise. Tempest is also very dear to me. I love her. I’ll take good care of her.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With that, Jordan scooped me up into his arms and swept me away to his silver Bentley where he buckled me in, leaning in to brush his hands against my breast as he turned my face towards his to kiss me. His mouth took over my mouth, kissing me deeply, passionately. “I want to eat you up,” he said against my ears. “You’re even sexier when you’re flushed like this with your cheeks all pink.” He pulled away and started the car. “It makes me think you’re thinking of naughty things.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Aren’t you afraid of catching what I have?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jordan chuckled. “You don’t have a cold. Even if you do, I’ll risk it to make love to you.” He gunned the car so we were flying through the streets. “I want to fuck you so badly, I was afraid I couldn’t hide it in front of Aunt Helen. Good thing we cut our lunch short with her. But we will definitely have dinner with her soon.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I still couldn’t believe it. Helen was royalty, and she was Jordan and Kaz’s great aunt. Who knew the sweet old lady living across from Lily and me, in a small trailer, was a real life princess. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("After all these years, she took care of us like family, and I didn’t even know anything about her real family only they caused her so much stress and turmoil, she moved away from her country to live simply but happily on her own. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You must love Helen to trust her with your plans to become King,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“She was the one to suggest it,” Jordan said. “When I was in my early teens and was bullied in school.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Bullied?” I asked. “Why?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I was the eldest son of the King, but wasn’t the crown prince. People made fun of me and my mother behind our backs. At school, because I was skinny and tall all my life up to then; I was picked on.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Poor you,” I said, “Even as a prince you were bullied. But you’re not skinny anymore.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Because I was a prince, I was bullied,” Jordan said. “I was one without the favor of my father so despite being a prince, I was an unpopular one, cast aside by my father so that meant it was alright for the bullies to think I could be cast aside as a person.”  He paused and said, “Humbling experience but it made me realize that I was just a person like everyone else. Despite my title as a prince, I was just a skinny awkward kid. So I started taking martial arts, bulking up, and got in shape. Became a fighter myself...hence my interest in Underground Fighting.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We arrived at a hotel where Jordan quickly walked me to a private elevator which took us directly to the penthouse suite.  “So underground fighting wasn’t just a hobby. You’re a fighter, too.”  Suddenly, Jordan just became very interesting to me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, I fought in a few fights anonymously to get out my frustrations. I could relate to Ori like that.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ori. At his name, I remembered how incredibly magnificent Ori looked as the White Night. Powerful. Beautiful. Our bodies responded so well together. White hot chemistry scorched between us. How I missed his kisses, his touch. But then again, he had hurt me so badly, I destroyed him...his career as an underground fighter. Maybe that was for the best. As a crown prince, maybe he shouldn’t be such a playboy. Maybe he would be a better prince if he paid more attention to running his country.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But maybe he could do both? Like Jordan, who seemed to have his act together.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You live in a hotel?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Easier than maintaining a house which I will only live in a quarter of my time,” Jordan said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How do you run your businesses here in San Francisco when you’re busy running a country?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Same with you,” Jordan smiled. “How do you do it all, Tempest? I know you actually manage and run 3 Kings Technologies every day on top of being a student at Kingsbury.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Guess we’re very much alike,” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Which is why I was drawn to you immediately,” Jordan said. “I thought I found someone who could understand me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“A prince who was shunned,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It made me relate more to people than I did being a royal,” Jordan said. “Shunned by my own family and by royals.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The elevator door chimed, and Jordan pulled me to him, sweeping me into his arms as he carried me to the only door on the floor. The penthouse suite.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He went to a panel on the wall, press a button and immediately place his eyes to the screen.  The steel-enforced door opened, and Jordan swept me into a contemporary yet stylish suite that looked as cosmopolitan and sleek as Jordan himself. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He carried me to a large bedroom in greys, black, and white and laid me down on a luxurious bed with a large white comforter, silk sheets, and fluffy pillows.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh this is heavenly,” I said, laying out and spreading my arms. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jordan slipped off my dress with one pull. “I love it when you wear a dress I can pull off with one hand. So convenient.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You know me,” I said. “I like convenient things. Makes life easier.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” Jordan said, already licking and sucking on my nipples. He was on fire as he kissed the other breast while his fingers played with my clitoris.  “So convenient to have you buck naked so quickly. Nothing to get in the way of a quick fuck.” He rammed into me, as I let out a loud pleasurable moan. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, make it quick and dirty, Jordan,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I intend to,” Jordan said, rocking into me, bringing me to ecstatic heights. He thrusted in and out rolling his hips. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh my God that’s so good,” I let out between clenched teeth while he pounded against my clit with each hard thrust. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I knew you need it harder,” Jordan said. “You’re a fighter. Gentleness won’t do it for you. You need a good pounding.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, I do,” I panted, grabbing Jordan’s rock hard naked butt and pulling him deeper into me. He was built so beautifully. All tight muscles with little fat. He had been training for sure. Most fighters wished they had a magnificent body like his.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You’re so beautiful, Tempest,” Jordan said, his turquoise blue eyes looking into mine as he kept thrusting into me. “You took my breath away the first time I saw you on stage. I think I fell for you right then.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He cupped my face with his hand as he leaned in to kiss me, still thrusting into me harder and harder until I was exploding against him. He closed his eyes and arched his back, climaxing at the same time. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“God, I love you,” he said, kissing me again. “I hope you feel the same way about me. But if you don’t...you will.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I kissed him back. As much as I loved Kaz... I was no longer with him or the K3s. I wasn’t really with Ricky too, exclusively. But I had developed feelings for him too, especially when we seemed to have this connection in the past somehow. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I looked into Jordan’s eyes and said, “I don’t know how I feel yet, but I do care about you, and well...if Helen didn’t give you a stamp of approval...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jordan’s eyes lit up. “She did, didn’t she?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I nodded but wondered why did she send me to Kingsbury to make Kaz fall in love with me only to break his heart so I could be with Jordan? What was she planning, and why was I her pawn?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Tempest")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I slept for a while enveloped in Jordan’s arms. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I was in deep sleep before I knew it. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tempest?” a male voice said to me, trying to wake me up. “Wake up, we have to go, daughter.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I opened my eyes and looked into the brown eyes tinted with violet and purple lights of a man with grey hair and a beard. Dressed in a blue velvet robe embellished with gold threading and embroidery. The Kingmaker. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I looked around me and saw I was in my room at Kingsbury Castle. It was the ancient room Ricky had shown me, hidden behind a wall with a secret door down in the underground. The room was almost the same as it had been when Ricky brought me there...the wooden table, the walls covered in tapestry, the stone fireplace. Only now everything in this room was new, the colors of the tapestry more vibrant, the painting on the wall of me surrounded by young noblemen on horses with a knight...freshly painted.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I was dressed in an old-fashioned white sleeping robe. My hair braided into a long braid, threaded with silver. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Father,” I said. “What is it?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hurry, child,” he said. “We must go. No time for talk. Get dressed warmly and follow Lucinda down the corridor. Bring your sword and the Kingsbury dagger. Prepare to fight if you have to.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Why? Who must I defend myself against, Father?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My father pulled out my riding garment, a cloak, and boots. “A crown prince who lost his kingdom just now because I delivered the message that the next King of his kingdom would not be him, but his brother. As an act of revenge, he swore to destroy Kingsbury Castle, me, and even you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, Father, it can’t be,” I said. “Crown Prince Avery would not hurt us. He swore he loved me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’s not Avery, but the other,” Father said. “I gave the crown to Avery at the last minute, changing my mind and going against what the other had believed to be the expected choice. Now Kingsbury will be attacked by his army. We must retreat elsewhere for now.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, it can’t be. The Other brother...he led me to believe he loved me, too. That he wanted me as his queen.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“He may love you, Daughter, but now he feels betrayal from us. I can’t blame him for it would seem what I had done was a betrayal.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You did it for a good reason, Father,” I said patting his hand. “You must have seen the truth of it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, Daughter, I did.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So now instead of love for me, he has hate,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Love and hate are strong feelings, Daughter. When one loves someone but feels that he has been wronged by them, that betrayal can turn to hate quickly. This is how the other brother feels towards you. That’s why you must leave now. He will be looking for you. He will want to seek his revenge on our family through you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I quickly changed and went to Lucinda who was holding a lamp and dressed in a riding cloak. In disguise as my maid-in-waiting, she was highly trained in martial arts from the Orient and in swordplay as a knight. Lucinda was also my fighting instructor, who taught me how to fight, better than any man.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Where will you be, Father?” I asked, leaving with Lucinda down a secret passage. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I will be trying to keep the castle. Kingsbury must not fall.  If it does, there will be chaos amongst the kingdoms. More wars fought as one prince battle over another for their kingdoms. The Kingmaker and the legacy of the Kingmaker must last so there will be peace. As a Kingmaker yourself, you will have the power to discern. You will have power over princes and princesses to determine who will rule. For centuries, to appease the people and to appease their own families without trying to divide them by their own decisions; kings have relied on the wisdom and vision of Kingmakers to choose the next Kings. I must not let this tradition die out because of some insubordinate rebellious prince. I will defend Kingsbury to the death.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Father, no!” I said. “I will stay then. You go with Lucinda. Or Lucinda will stay with me. I will not leave you here to defend the castle.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I have my own army out in the wilderness, ready to fight,” Father said. “There is a band of knights within the castle, led by Honeywell and his son. There are a few at the landing below to attack as soon as they step on ground. Then we have our ships out at sea, ready to fire arrows and cannons at them if they dare enter these waters. We are well prepared. There is no need for you to stay and fight.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I beg to differ, Father,” I said. “There is a greater need for me to stay and fight. I will be safer here than anywhere else. I know Kingsbury Castle so well, I can help lead an attack or a defense anywhere. My leadership and training as a kingsmaker and the future heir of Kingsbury Castle and the Kingsmaker legacy is needed here. I will not run like a coward. I will stand my ground. No one will dare question my authority as Kingmaker, even as a woman, by doing so, Father. I will stay to fight.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Father smiled proudly and patted my head. “Spoken like a true Kingmaker. I thought you would run like others before you, but you have the heart of a strong kingmaker...one that would inspire and lead kingdoms. I am proud to have you as my daughter.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I hugged my father, knowing how he had wanted a son at first but was blessed with his only child, a daughter.  I will prove to everyone who thought only a son could be a kingmaker, that a girl could be one too. There would be no question about the gender...only who would be the best to lead. Me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("As to the man who would dare attack my castle and harm all within...I would deal with him on my own. After all, as I suspected yet needed to confirm, he was attacking due to feelings for me. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Father, I will seek an audience with him,” I said, rushing out the door towards the courtyard filled with knights and my father’s army. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The young knight, Henry Honeywell rushed towards me.  “Where are you going, My Lady?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“To talk to him, Sir Henry, it is all because he feels not only the loss of a kingdom but of his lady that he is attacking Kingsbury Castle. I will put a stop before it begins. Let me through!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It is too dangerous,” Sir Henry said. “Please, don’t go out to certain death. We need you alive. You are the heir to Kingsbury. We need you. I need you...” Sir Henry pleaded with his eyes, displaying his full love and devotion to me, having declared his love for me since childhood. “Since I know how headstrong you are when you want to be, remember when we were children,” he said, “there is a creek that runs through the castle to the ocean. You are a strong swimmer. If your meeting with him turns for the worse, find the creek. There will be a boat there with reinforcement. I should be there waiting for you.” He bowed. “I will protect you with my life.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Henry...” I began. I knew he wanted to accompany me to my meeting with my prince lover, but I had to go alone. Otherwise, Henry would seem like a threat to him and be killed instantly on the spot. “I must see him alone.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But he is out of his mind with hate and hurt. How would you be able to talk to him?” Henry asked. “He would kill you on the spot.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That’s a risk I’m willing to take, Henry. No one should die.  No one has to die. Farewell.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“My Lady!” Henry cried out as I quickly kissed his cheeks and ran towards the gate, beckoning for the guards to open it. When they refused, I jumped up on the top of the gate, having learned the power of Qi Gong from the Far East, and jumped down to the ground below, landing softly on the grass near the beautiful rose bushes planted at the entrance of Kingsbury Castle. I plucked a red rose from one of the bushes and fasten it to the neck of my cloak, visible for all to see.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A red rose.  The symbol of romantic love.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("His soldiers were lined up along the outer perimeter of Kingsbury Castle. Below on the landing were ships anchored to the beach in the bay. There were enough to storm and overtake Kingsbury Castle. He had come prepared. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And as he sat on top of his magnificent black steed, dressed in black and silver, with his dark blue-black hair flowing behind him, a hint of silver shining from one of his ears; Prince Axel stared back at me with his steel blue eyes, eyes that once looked upon me with hate, then with such love and admiration. I could feel his eyes on me as I made my way to him, taking me in from head to toe, the heat of his stare unwavering. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Prince Axel,” I shouted, walking towards him. “Give me a moment to speak with you in private. Please.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Violet,” he sighed. “What are you doing out here?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I want to see you, to talk to you, Axel...be alone with you.” I lowered my eyes to look at him before looking down. He knew what that meant. He had acted upon my look to him several times before in many places...places where we would meet in secret, places where we could not restrain ourselves. Prince Axel and I had always had an intense connection, which we could not ignore when I became of age, and he finally took me. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("An amused smile lit his face slightly. “Even now, you drive me crazy, woman.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Axel...I know who I want now...who I will choose to be my husband. But I want to know if he still feels the same about me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Prince Axel’s eyes widened with surprise. His stern unyielding expression softened and he held up his hand to let me come closer pass his barricade of men. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My eyes were on his, full of love. Full of promises for a happy future. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Violet,” his voice came to me as a caress from the wind. “My love.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In my eyes, I only saw him.  My bad boy prince who had always made my heart flutter. He brought out the strongest passions and desire in me. Love, hate, pain, and happiness. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I didn’t see the arrow that came towards me, until I fell to the ground. I felt the sharp pain pierced into me, numbing me instantly so I couldn’t move.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Violet!” Prince Axel’s voice cried out in agony.  “Violet! No! No!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Then all went black.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Tempest")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Get up!” a strong male voice said, nudging me gently.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No! No! No! Axel...” I cried out.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Open your eyes,” the gentle nudging became a firmer shaking. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I opened my eyes to look into beautiful turquoise eyes. Jordan. He was lying in bed next to me, his thick eyebrows furrowed in a look of concern. “Jordan?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, Tempest, Baby,” he kissed my forehead. “You were screaming in your sleep. A bad dream.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It seemed so real, Jordan. I swear I was there...back at Kingsbury Castle with the first Kingmaker.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jordan lifted me to hold me in his lap, holding me tight. “That’s because you are a kingmaker, Tempest. You are a direct descendant of Kingsbury. And that makes you very very special.” He smiled. “The kingmakers have the gift of sight.  Visions of the future, especially when it concerns kingdoms.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But wasn’t that just something from ancient days...medieval times when there were knights and ladies?” I asked. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Believe it or not, Tempest, many of the royal families still believe in the visions of kingmakers. My father is a believer. And many of the families attending Kingsbury Prep are believers, which is one reason why their families attend the Kingsbury.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He leaned in and nuzzled my ear. “So what did you dream about that had you screaming bloody Mary?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kingsbury Castle was about to be attacked, and I was trying to stop it before it began.  I knew the attacking prince. I loved him. But he felt betrayed by me, by my father. I was trying to stop his attack on the castle but when I went out to meet him, I was killed.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I shuddered, and Jordan hugged me tighter. “What an awful dream, my poor Tempest.” He kissed the top of my head and said, “Although dreams are significant for kingmakers, don’t take too much heed in this one.  If it upsets you, it’s just a dream.” He rocked me in his arms and said, “Only a dream.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I shook my head. What was the dream telling me?  Would one of my princes eventually kill me?  Or was it someone else? ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I looked at Jordan, and he kissed me again, unraveling himself from me.  “I promised you an unforgettable weekend in San Francisco as a way to get to know each other better, and I’m failing miserably, aren’t I?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I laughed. “No, it’s my fault, Jordan.  I was the one not feeling well when we were about to have lunch with Helen.  Then now here I am waking you up while screaming in my sleep.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No matter what we do, Tempest, I’m just happy being with you,” Jordan said. “But I’m sorry about this...I have an emergency I have to take care of at the Underground Fighting Network. I’m not in town often so I need to go into the office.” He got out of bed and walked over to his closet, changing, while talking to me.  “I don’t know when I will be back tonight. You may have to have dinner with Helen alone.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No worries,” I said. “San Francisco is home for me. I can easily find something else to occupy my time here.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I walked into the closet as Jordan was pulling on a black Armani blazer. He looked so handsome as he came over to corner me against the wall, putting his arm up while he kissed me. “I want to spend all my time with you, Tempest, but I have to go. Sorry I can’t divulge too much now. I’ll make it up to you I promise.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Alright, Prince Jordan, I bet you will. Bye!” I waved.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He rushed out, looking at me with regret. A buzz came through on his phone, which was on the nightstand, and I took a look at it before rushing out to catch him. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You forgot your phone,” I said, handing it to him at the elevator as he got in. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Thank you, Tempest,” he said, looking a bit flustered. “I don’t know where my head is right now, but I think I left it with you along with my heart. I love you, Tempest.  I’ll get back as soon as I can.” He kissed me and left.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I let out a deep breath as I grabbed my bag from his suite and waited for the elevator going down.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I had to get back to Kingsbury Prep and Arcadia as soon as I could.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I still couldn’t believe my eyes at the message that came across Jordan’s phone.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("TEXT TO PRINCE JORDAN:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("KINGSBURY CASTLE was Attacked.  See to it that Kaz is alright. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Why didn’t Jordan tell me this? And why was he ignoring it and heading to his Underground Fighting Network offices instead?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Hunter")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Kingsbury Prep Academy")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("2 Hours Earlier")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene with-quote character-i"
  }, [_vm._v("“I")]), _vm._v(" HAVE ONE MORE DAY")]), _vm._v(" here at Kingsbury before I have to pack up and leave for however long until I can come back,” I said to Kaz sitting on his favorite side of his leather sectional sofa in the living room of his large house at Kingsbury Prep, known as Kaz’s Place.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That’s just unbelievable, bro,” Ori said from across the room where he was on the floor doing pushups. “That you can be expelled just like that.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yeah,” I said. “I find it unbelievable that you used a forbidden substance in order to win all your underground fights. Making your wins null.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ori stopped after pushing up and letting both arms bend before crashing down to the floor. “It isn’t true, you know,” he said. “I never used any substances before a fight.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We know that,” I said. “We know how healthy you keep yourself. You don’t even eat junk food. So why would you use a prohibited substance, especially before a fight?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Exactly,” Ori said. “I never have.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And I’ve never done anything at Kingsbury to get me expelled,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ori and I looked over at Kaz.  He was still in the same position as he’d been since two days ago, after he had returned from some Student Council meeting held at the Arcadia Inn. Since returning, he had sprawled out on the sectional, looking almost comatose, just staring up at the ceiling. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kaz?” I made an effort to snap him out of it. “What do you think?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yeah, Kaz,” Ori said. “What do you think?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("No response.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("When he returned from the Council meeting, trying to reinstate me back into Kingsbury Prep, he didn’t say anything. He just had a blank expression, like he had seen a ghost. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I take it the meeting with the Student Council didn’t go well,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That’s an understatement,” Ori said. “It not only didn’t go well, it made him like that. Frozen.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I have one more day before I have to clear out of Kingsbury as a student,” I repeated, mainly to Kaz. “After that, I can’t be on campus. I can’t help you out, Kaz.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Why did all of this happen?” Ori asked. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tempest!” a loud roar filled the room.  “It was all because of Tempest.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ori and I turned our heads toward the roar.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kaz.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He was up and looking as mad as hell. “Tempest!” he was now pacing. “And Jordan!” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You think Tempest is behind all this?” I asked Kaz. “I know she has her reasons. We were so awful to her.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Jordan, too,” Kaz said. “I saw them with my own eyes at the Inn, going at it. They got me to go to the Inn, thinking the meeting to clear Hunter from being expelled was there. I went there only to catch them in bed together fucking.  And that blonde surfer-looking dude who has the hots for Tempest. He was there too, fucking our Tempest. She,” Kaz gulped, “never looked so hot. I couldn’t take my eyes off her.” His eyes were glistening with unshed tears, “She was breaking my heart, but I couldn’t stop watching. Even though she was with two guys whose guts I hate more than anything.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I clenched my fists. So Kaz was right all along. Tempest did betray us. With Jordan. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“She set us up to fall in love with her, then break our hearts,” Kaz said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No,” Ori said. “That can’t be right. How could she when she only learned of us when she arrived at Kingsbury? She didn’t even know a thing about the Underground Fighting Network until she fought me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My head was reeling. Kaz saw Tempest willingly and apparently enjoying having sex with Jordan. My heart was shattered. She had moved on with Jordan and that local boy. My eyes filled with tears and I wanted to bawl my eyes out. “She really was over us. She had moved on to someone else. Jordan and Ricky of all people. I can’t believe it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Losing Tempest for good was worse than anything I had ever felt. Worse than being expelled. Worse than losing my music career. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I believe she still loves us,” Ori said. “I think she was Jordan’s pawn.  He used her pain to get us, to twist things around for himself. After all, guys, we were the ones who broke her heart first. We deserved her revenge. Even when it’s with someone we hate.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kaz stopped pacing and said, “I’ll get you reinstated as a student, Hunter. Don’t pack up your things yet.  And Ori, we’ll clear your name of those false claims about you using substances to boost your fights. Tempest got back at us, I understand, and she’s had her revenge. Now it’s time for me to reclaim my kingdom. And our girl. But first...I need to know more about Jordan’s plans and how much our Tempest played in it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“As we speak,” I said, looking at several screens on my laptop, “Tempest is with Jordan in San Francisco.” I couldn’t help feeling pure jealousy as I thought about Tempest with another man, outside of K3. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Looking around me at the guys, they all had looks of pure jealousy on their faces. It was primal...men claiming their females or female in our case.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ori spoke first, “So we can’t get to Tempest to talk to her in person at the moment.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kaz said, “But that blonde bastard she kept spending the night with...that commoner Rich something...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ricky,” Ori said.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ricky,” Kaz continued. “He’s here on campus. Works in the kitchen.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What do you intend to do?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Let’s grab him and get him to tell us what he knows,” Kaz said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Okay,” Ori said. “Shouldn’t be too hard. He’s here on campus already. All we need to do is bring him here.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Tempest")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")]), _vm._v(" FOUND THE FASTEST")]), _vm._v(" airplane I could find to get from San Francisco to the island of Arcadia where Kingsbury Prep (aka Kingsbury Castle) was located.  It wasn’t a regular commercial airplane, but a military one, which I had to pull strings for using my 3 Kings Technologies connections. What would have taken hours by regular commercial flight took only about two hours. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It gave me time beforehand to visit Lily and to catch up on everything. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m sorry this visit is so short,” I told Lily, hugging her in Lily’s secret apartment at the 3 Kings Technologies headquarters. “I’ll be back soon, Lily. Before you know it, I’ll graduate from Kingsbury, and back in San Francisco to help run 3 Kings Technologies with you again. But tell me something that’s going on that you can’t tell me over the internet or the phone.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well for starters,” Lily said, “I figured out why Mom and Dad needed those binders on top secret defense weapons and on designs for new planes and ships.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Didn’t we already figure that out?” I said. “I thought it was for the highest bidder on military grade new weapons?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“There’s more,” Lily said. “It has to be significantly more for Mom and Dad to have risked their lives protecting it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What is it?” I asked.  “I don’t have much time to keep guessing so just tell me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mom and Dad not only had contracts with the US government, but look at this...”  She pulled out another binder, which I had never seen before. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Fighter ships with smart technologies. Brains in the airplanes, the ships, the vehicles...including a satellite,” I said, looking at the plans kept in the binder. Incredible. Mom and Dad were geniuses.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Duh, how else did you and me inherit the genius genes?” Lily said. “Two geniuses marrying each other and having kids together...one of us was bound to be a genius.” She did an exaggerated wink. “Guess it had to be me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I tugged at her side braids and said, “No doubt you’re the genius.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She laughed. “I was just joking.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And I’m not,” I said. “You are a genius.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So Tempest, since you’re not just my big sister, but guardian...I’m doing so well in the homeschooling one-to-one school system, they want me to skip some grades.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’s up to you, Lily,” I said. “You’re not only a genius but you’re mature, too. Most kids can’t handle what you do. Even some grownups.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I want to skip some grades then,” Lily said. “The sooner I finish with the regular school, I can get into college, then graduate studies.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Maybe you can skip high school all along and join me in college,” I joked. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“If I skip three grades I might be able to,” Lily said.  “Wouldn’t that be great...us attending the same university so we can be together.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That would be so wonderful, Lily,” I said hugging her tightly. “I want to be together again. I wished I could make it back here all the time to be with you. I’ll try to, now that I’ve found a new way to fly.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tempest,” Lily said. “Maybe we can design and produce new planes that are more amazing than that?  We have the plans in that binder. I think Mom and Dad were planning on building those planes. They may have already.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“They were on a business trip when they died. “Maybe it was where they had built a plant and they were already secretly manufacturing everything in those binders?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Possibly,” Lily said. “Just where would they put a plant like that?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“A secret hideaway place no one would think of having a manufacturing plant at,” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Right. Sounds like either the desert, mountains, or an island,” Lily said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“If there is one, we’ll find it,” I said. A text came through just then, and I gave Lily one last big hug before heading out. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, Tempest,” Lily said before I was completely out of earshot. “That other prince you started seeing, I found something on him. I’ll text you what I found later.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I nodded and waved good-bye and headed down to the lobby of 3 Kings Technologies. It was good to be back in this building where Lily and I grew up playing and hanging out at our parents’ offices. They were so busy building their company, they brought us to work. So running the company felt natural, since we’ve been a part of the family business since we were toddlers. But now, having discovered we were not only just a technology company but one building weapons and innovative new modes of transportation, suddenly our little company was now on the radar of people and organizations that would do anything to have what we have...to know what we know.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I sent Lily a quick text telling her I loved her and to keep safe. As soon as I figure out what our parents had been building and where was it, I’d relocate Lily elsewhere.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 6 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Ori")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("After our discussion at Kaz’s place, we decided we had to get a confession out of Ricky, to find out if he knew what Tempest had planned.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I hated having to investigate Tempest like this...going through a friend to get through to her. I also thought Ricky was a good guy. He had proven himself to be reliable and trustworthy that night of the Kingsbury Birthday Bash when he gathered over a hundred local townspeople to help act as security for the Bash after my own security team failed to show up. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We waited for him at the end of his cafeteria shift and found him walking along the trail towards the tram back into town. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hey Ricky,” I said. “How’s it going?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He stopped walking and looked over at me, Hunter, and Kaz, all standing together. “Hey,” he said. “Haven’t seen you guys in a while.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How’s Tempest?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tempest?” Ricky asked. “I haven’t seen her in a while. Wouldn’t you guys know where she is?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We thought you would know since you’ve been hanging out with her a lot recently,” Kaz said, with a bit of an edge to his tone.  He could barely retain his jealousy of the fact Tempest was now seeing and being fucked by this guy. The thought of that made my blood boil, too.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ricky was just as big, tall, and athletic as the three of us. In the looks department, he was considered handsome too, especially in a blonde surfer way, which probably reminded Tempest of her home in California. Maybe that was why she got along so well with Ricky. Friends at first, but when we hurt her so badly...she found comfort in the arms of this horny bastard who wanted to be her friend with benefits. We all saw it a mile away. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kaz was looking at Ricky up and down, sizing him up and probably wondering how the hell this guy could think he could compete against a bunch of princes. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We need to ask you a few things,” Hunter said. “If you would come with us.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” Kaz took Ricky’s right arm, while Hunter took his left. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ricky’s eyes flew wide open in alarm. He struggled to get out of Kaz and Hunter’s hold on him, shouting loudly, “Let go of me!  Let go now!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Other employees and staff of Kingsbury Prep were walking passed us on the trail to go down to town where they lived outside of Kingsbury. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They looked surprised and alarmed as they saw Kaz and Hunter dragging Ricky along, while Ricky struggled.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hey!” one of them said. “Why are you dragging Ricky away?  What did he do?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Another ran down the trail as fast as he could to town, shouting, “The royals have taken Ricky. They’re black enveloping a common staff member now!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“They’re going after common people who work for them now!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The shouts became louder and louder.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Down below in town, a gathering of people started making their way up the mountain.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Stupid spoiled royal brats!” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Think they can get away with anything just because they are royalty!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We pay taxes so high to support their lazy no-good asses!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How dare they mistreat Ricky Honeywell! The Honeywells have been the pillar of society long before there was an Academy!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“All their stupid games they play must end!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Their brutal bullying and elitism must end!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The crowd was getting larger and larger. I ran over to Kaz and Hunter. “Guys, let Ricky go. It looks like we just incited a mob.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What?” Kaz asked. “How could they?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Someone threw a rock which nearly hit Kaz’s head. His eyes grew wide, and he dropped Ricky’s arm. “Come on, guys, this is getting dangerous.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Another rock was thrown. This time it hit Ricky’s shoulder which made him fall into Hunter, knocking him down.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kaz and I helped Hunter and Ricky up, grabbing their arms to begin our retreat.  “Quick, back into the school!” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ricky winced as blood gushed out of a gash where he was struck. Kaz and Hunter hoisted him up between them and began running as fast as they could with me trailing behind. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Leave me,” Ricky said. “It’ll help you run faster.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, you’re hurt, and they’re acting too crazy,” Kaz said. “They’ll stone you to death too, thinking you’re one of us.”  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A rock hit Hunter’s back, and he slumped over a bit before straightening out. “God that hurt like a son of a bitch!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Just around the corner, and we should be within the gates!” I said, helping Hunter by taking his shoulder and wrapping his arm around mine to boost him up. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I looked back, and my mouth fell opened. There were maybe a hundred or more people from town not too far behind us now, carrying weapons, including rocks, knives, axes, shovels, and whatever they could get their hands on. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I felt like a monster on the run from the village.  Frankenstein. Dracula.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We finally made it to the gate where I quickly punched in the security code, and the gates opened.  “Hurry!” I shouted.  We stumbled our way in. “Close the gates quick!” I yelled at the guards standing by the gates.  “Quick! We’re under attack!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("When we made it further in, we collapsed onto the grass. I had been hit a few times by the rocks, and it was stinging where I was struck on my back. Hunter had blood flowing from his shoulder and back. Ricky was bleeding from his shoulder and Kaz...had blood flowing from the top of his head.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("His eyes were closed. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He fell unconscious.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kaz!” I shouted.  “Wake up!” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Hunter shook Kaz too, but Kaz’s eyes remained closed. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Quick, someone get a doctor!” I shouted. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Hunter had turned pale and was shaking Kaz. “Kaz, wake up. Wake up. Please be alright!”  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Damn it! Get a doctor now!” I ran to the administration building and banged on the door until someone opened it. “Emergency!  There was an attack on Kingsbury and Kaz isn’t responding. He was hit in the head with a rock.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Someone rushed out to see Kaz, and a few more ran out from behind him. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You’re bleeding too,” someone said. “A lot. Massive cuts and gashes on your back. We need to stop the bleeding or you’ll have too much blood loss.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I was taken into the nurse’s room and laid down on one of the beds. As soon as I hit the bed, my eyelids felt heavy, and I felt so warm.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Get some blood, Type A!  He’s lost a lot of blood,” I heard someone said before I drifted off.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 7 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Kaz")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-t"
  }, [_vm._v("T")]), _vm._v("HE WIND WAS BLOWING")]), _vm._v(" my mother’s long black hair against my face as she played in the sand next to me. She was laughing and giggling, as carefree as any island girl, enjoying a beautiful day at the beach. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A moment of distraction, and my mother and my nursemaid left me to wander down the beach by myself, my curious five-year-old legs eager to explore the vast openness of the clear blue water before me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Up ahead of me was my older brother barely 7 years old, wading in the water in the middle of a blown up plastic penguin float.  I wanted to follow him. I wanted to float in the water like him. Just like him. Just like Jordan, who I admired and thought was the best older brother anyone could have. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I wandered deeper into the water, trying to reach him and his penguin float. But my little legs were too short to walk up to him. I was drinking in water so salty I was coughing it out.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mama!” I cried out when a wave of water hit me and almost knocked me over. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kaz!” my mother’s voice panicked. “Where are you, Baby!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“There he is!” my nursemaid shouted running into the water from the beach.  “He’s near Prince Jordan.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My mother ran into the water as a wave hit me and knocked me into the water where I sank beneath.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kaz!” I heard my mother’s voice drifted.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Then hands were on me, lifting me out of the water. I was sputtering water but I had trouble breathing. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Quick, he needs resuscitation. CPR. Step aside,” a voice said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Hands were pushing down on my stomach.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I cried out in my toddler voice, “Mama! Jordan!” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Then a gush of water flowed out of me, coughed up before I could breathe again. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My mother was crying. Then I heard my father’s voice. “There, there. He’s safe now. He must have wandered after Jordan.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“He almost died,” my mother was crying. “I almost lost my sweet baby boy...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Jordan!” my father’s voice called out, stern and unforgiving. “How could you let your little brother go into the water after you? Didn’t you see him next to you? You are his big brother and you can’t even take care of him? He almost died because of you, Jordan. What kind of a brother are you?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“There, dear, Kaz is fine now. Don’t blame Jordan,” my mother said. “He’s just a child.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Child or not. He is old enough to know better. He’s a prince. The eldest. I was already performing princely duties at his age. This is no excuse. There will never be an excuse for him.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I sat up to see Jordan’s face streaked with tears, his mouth crumbled as he cried. “I didn’t know Kaz was in the water. I didn’t see him. The waves were so loud! I’m sorry, Father! I’m sorry!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("From that day on, things changed between my older brother and me. Things changed between my mother and Jordan’s mother. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Even my great Aunt who was playing with me on the beach, my Aunt Helen changed as she scolded my father for his treatment of Jordan. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A few years later, my father said that I would be king after him. I would be the crown prince. When I asked him why he didn’t choose Jordan since he was the eldest son, he didn’t say why, only that he believed I was the destined one. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And now that had changed. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 8 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Tempest")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")]), _vm._v(" HAD ARRIVED AT KINGSBURY")]), _vm._v(" Prep as fast as I could and landed on the landing strip inside of Kingsbury Castle’s walls. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("From above, while the plane was landing, I could see the dark mass gathered along the walls of the castle, with fire.  As we flew closer, I could make out the figures of men and women wearing common clothes, carrying torches and rocks. They were shouting and banging on the walls of the castle.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I couldn’t believe my eyes.  It looked like a scene out of a horror movie...a growing mob of townspeople carrying pitchforks, knives, rocks, and torches ready to burn down Frankenstein’s castle.  Burn down the monsters.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("What happened? What made the usually friendly easy-going people in town become a mob ready to take down their keepsake castle?  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("As soon as the plane landed, I thanked the pilot, and ran out to the main campus. I didn’t pack anything except my tote bag and quickly made my way to the administration building.  Maybe I can get some answers there.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A woman on staff walked by and I grabbed her arm, getting her attention. “Excuse me, have you seen Kaz? Hunter? Ori? The K3?” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“In there,” she gestured. “They were hurt really badly. One of them...” she turned her head away. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My heart sank as I realized what she was saying.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It took a moment for me to gather myself.  What if one of my boys was so badly hurt or was on the verge of dying?  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I couldn’t think of losing any one of them.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I walked into the nurse’s office and found Ori all bandaged up.  He had a pouch of blood dripping into him, and his eyes were closed. “Oh Ori, I’m so sorry about what happened.” I kissed his forehead. He still had his eyes closed, but when I kissed him, they fluttered open. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tempest?” he said. “You’re here? Am I dreaming?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m here, Ori,” I said. “I’m sorry what happened to you. I got here as soon as I could.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Thank God,” he said. “It feels good to see you again. See you smiling.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How’s Hunter? Kaz?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hunter’s over there.  Ricky’s next to him.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I kissed Ori and said I’ll be back after I see the others, and went to Hunter.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("His eyes looked so surprised to see me as he gave me a sweet but sexy smile. “Tempest,” he said, his voice like seduction to my ears. “I’ve missed you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I kissed him on the lips and said, “I missed you so much, too.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Why are you here?” he asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I heard about the attack on Kingsbury and had to come back.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Your timing is impeccable,” Hunter said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You know me,” I said. “A born comic.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Hunter chuckled. “So beautiful yet so funny. A perfect combination.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I smiled at him, happy to be with him again. Happy to be talking to him again. I sighed. Looking at him, I couldn’t even remember why I stopped talking to him. “I miss your handsome face,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He grinned. “I bet you miss my mad skills at everything sexy too.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How’d you guess,” I said.  “I do, but first, I have to go see Ricky, who is waving me over. Get well fast, Hunter. I want to see those mad skills in motion, but if you’re injured like you are...it’ll have to wait.”  He gave me a sweet but sexy smile. “Tempest,” he said, his voice like seduction to my ears. “I’ve missed you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Guess I’ll have to get better right away, Doll, because looking at you, I can’t wait to be in your good graces again.” He stuck out his tongue and made some licking moves that made me laugh.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I went to visit Ricky next, who reached out for my hand to pull me over to him.  He was bandaged up like Hunter and Ori.  “What happened to you?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I got stoned,” he said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Like stoned?” I made a smoking gesture.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Naw...literally stoned like someone throwing a stone at you. I know. Sounds like the Stone Age, but that’s what happened.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I wouldn’t believe it if I didn’t see how injured all of you guys are,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It just got crazy out there,” Ricky said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tell me more about everything when you get a chance,” I said. “In private. I want to hear all about it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I plan on it, Tempest.” Ricky smiled, pulling me in close to kiss me on the lips. “By the way, I really missed you.” He kissed me again, deeper, more passionately. “So sweet. I miss these lips. And the rest of you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I missed you too, Ricky,” I said. I looked down, “And Little Ricky, Ay yah yah!” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ricky burst out laughing. “And I love Lucy,” he said looking at my breasts. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ll be back, you silly man,” I said heading to the private room in the nurse’s office. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("So the one who was most critical was in this room.  It couldn’t be Ori, Hunter, and Ricky. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It was Kaz.  Kaz, who I had the most reasons to take out my revenge on.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kaz, whose heart I had broken by becoming Jordan’s lover.  And for whom my own heart had broken after realizing the consequences of my actions. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I walked quietly into the darkened room and stopped. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Even with his head bandaged up, his face bruised, too; he was drop-dead gorgeous.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kaz,” I whispered, mostly to myself. He had his eyes closed, and looked so peaceful like a little boy.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I sat in the chair next to his bed and reached out to hold his hand. His eyes twitched and I squeezed his hand, letting him know I was there. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I sat there for a while just holding his hand, almost falling asleep, when I heard, “Tempest.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My eyes flew open and I looked over at him. His eyes were closed still, but his lips were moving, as in a dream.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tempest,” he said. “I’m sorry for everything. I only did what I did because I’m a big coward. I hid behind my bullying of you at first because I didn’t know how to act with you. I was so stunned by you...your beauty, wit, sense of good, and nobleness. I’ve never loved anyone as much as I loved you. Take me back, Tempest. Please forgive me and take me back.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“For a sleeping comatose man, you are quite eloquent,” I said.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I bent down to kiss his forehead and realized his hand was holding mine. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("His eyes hadn’t opened yet, but at least he was responding to my touch.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I got up and pried my hand away. My head was spinning, and I was confused, tired from lack of sleep, but mostly I was elated.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("What could have been a much larger disaster seemed to have been averted. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I pulled out my phone and sent a quick text. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("ME:  Thank you for your help in arranging the free food and drinks for all Arcadia locals last night. You helped avert a disaster. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 9")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Tempest")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-w"
  }, [_vm._v("W")]), _vm._v("HILE THE BOYS WERE")]), _vm._v(" recuperating at Kaz’s place due to lack of space in the Nurse’s Office, I made it a point to visit the town of Arcadia at the base of the mountain as much as I could, wearing my Kingsbury Prep uniform.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Look, it’s Tempest Storm!” a small group of people said when I went into my favorite bakery to pick up some cupcakes and chocolate cake. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hi!” I said. I turned back to the sweet-looking girl behind the counter. “Um, can you give me a dozen of those sugar cookies, too?” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sure,” she smiled. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No need to package them up. Just hand me the whole tray.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She looked surprise at first, but then she nodded. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I handed her some cash and then turned around to face the small group of people gathering to see me. “I’m surprise you all recognize me!” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Big fan!” a middle age man said. “My daughter wants to learn mixed martial arts because of you. You’re her role model.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Aww!” I gave him a hug. “Thank you!  Here, I don’t have any swag or photos right now, but would you like to take a couple of cookies back with you to give to your little girl?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The man’s face lit up.  “Gosh. Wow. She would love that.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A girl about Lily’s age came up to me and said, “I have all your posters and dolls, but you’re much prettier in person.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I reached out and hugged her. “Thank you!  You are so sweet and very pretty too!” I handed her a cookie and said, “Next time you see me, if you have any of your posters or dolls, I’ll sign them for you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Her shy smile widened into a happy grin. “Oh I will! Thank you!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I went through the crowd talking to everyone and handing them a cookie until the last cookie was gone. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Could you visit my school?” the shy girl around Lily’s age asked.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Where is your school, um...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Cleo,” the girl said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Cleo,” I repeated. “Oh I love your name. So regal. One of my favorite females from history, too. Smart and cunning like a man, Cleopatra really knew how to make the most of her being a woman in a man’s world.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A woman dressed in a cozy sweater and jeans came up to me, handing me a card.  “Hi, I’m Cleo’s mother,” she said smiling. “Cleo’s probably one of your biggest fans. She just loves you and what you stand for, showing everyone that a girl can be strong, beautiful, and themselves. You know since you became the face for fighting, more little girls are learning martial arts and self-defense. We would love for you to speak at our school and possibly other places around.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I looked down at her card and smiled. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I would love to,” I said, “Mayor Roberts.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She laughed. “Just call me Liz.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Alright, Liz!” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She looked at my blazer bearing the Kingsbury crest and said, “I always wondered what it would be like when Kingsbury finally opens its doors to a non-royal. I grew up in Arcadia and despite having Kingsbury Castle right here on top of our mountain, there had always been a separation between the town and the castle.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Have your family lived in Arcadia long?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We’re one of the oldest families here,” Mayor Roberts said. “Since the days of the first Kingsbury, the Kingmaker.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, I’d love to hear more about that,” I said, hoping I would find something more about my ancestor Violet and her father.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’d be glad to,” Mayor Roberts said. She turned to Cleo, calling out her name.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Cleo came over, and Mayor Roberts said, “Would you like to invite Ms. Storm to lunch at our house? She can see all your Tempest Storm collection.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Haven’t seen all the Tempest Storm collection myself, I was interested in seeing Cleo’s collection. “I’d love that,” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Okay,” Cleo said. “Would you please come to our house to have lunch with us, Ms. Storm?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, Cleo, I would,” I said, smiling. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Would next week be a good time?” Mayor Roberts asked. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, I could make it,” I said. “Just let me know where and when.”  We exchanged phone numbers before Cleo and her mother left the bakery. When I walked up to the counter to retrieve my cupcakes and chocolate cake, I noticed a few more baked goods were added into my bag.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I was about to pay for the additions, but the sweet-looking counter girl said, “On the house. I’m a fan myself, and aside from an occasional visit from a rock star touring or a movie star stopping by on a film shoot, we don’t get much excitement. So I’m thrilled you’re here. And you’re not just visiting. You go to school at Kingsbury.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ve been here for a while,” I said. “I wished I visited the town more often...” I looked at the little name tag the girl was wearing, “Jenny. Had I known there were so many friends I could make in town, I would have gotten to know this town better.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jenny smiled. “It probably was an adjustment for you to go to Kingsbury so you were busy settling in. But now you know we’re here, visit us as often as you can. In fact, we have a bulletin board posted right there where you can see all the events we have in town. You’re welcome to join anytime.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, that’s great!” I said. “Anyone’s welcome?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sure,” Jenny said. She looked down. Suddenly acting shy. “If you want, I can introduce you to some of my friends, too. I’m still a senior at the local high school in South Arcadia. The girls and I, well, we get together for a book club every Wednesday night here at the bakery and I provide the pastries while the girls buy tea or coffee.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“A book club?” I cried out. “I always wanted to be part of one. My neighbor Helen is in one, and she gets really into it. Yes, I’ll join in.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We have one this Wednesday if you can make it. But you have to have read the selected book already before the meeting so we can discuss it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sure! Which book is it for this Wednesday?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We’re going through one of our favorite YA and New Adult authors’ books right now. The pick for this week is Loving Summer by Kailin Gow. It’s a contemporary romance with some very hot guys.” Jenny blushed. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Got it!” I said. “Getting a copy now.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Get the Limited Edition paperback one with the film cover,” Jenny said. “It won’t be around in that version.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Okay,” I said. I picked up my bag and waved. “I’ll see you in a few days!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jenny waved back, beaming happily.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I carried my bag of baked goods and walked into another shop.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The pretty Asian woman behind the counter welcomed me with a smile. “Hello!  How can I help you?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I smiled back. “I have some friends who lost a lot of blood and a friend who got cut up. Do you have any herbs or medicine that I can have to help them heal faster?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She looked around and walked over to pick up a few things before returning to me, placing her findings on the glass counter.  “This is good for blood flow. You add it with chicken or beef to make a good broth. And this,” she picked up a small bottle, “is an ointment you use to apply directly onto a wound so the skin will heal faster and there would be no scars.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Thank you,” I said. Then I saw another jar next to the ointment. “What’s that for?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“For you,” the shop lady said. “You practice Qi Gong, don’t you? Martial arts?” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I raised my eyebrows. “How do you know?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m a practitioner myself. I can see how you move and your form. You are a martial artist, and one who have been training for years.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You got that just from how I carry myself?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, and everything else around you. A true martial artist is aware and conscious of their every movement. You carry yourself with that caution. To me, it is obvious.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You must be very skilled,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Maybe,” the woman said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“My teacher in San Francisco had been training me to walk and carry myself with the lightness of foot for the past couple of years. Before that, I learned martial arts from various teachers, even a few from the Shaolin Temple in China.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I could see it,” the shopkeeper said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Instantly, I knew I was in the presence of a kung fu Grand Master. I bowed, showing respect for someone who could knock me out with just a gesture. It would take me years to even be able to develop the level of Qi Gong this woman had.  Grand Masters were few and rare around the world. “Grand Master,” I said. “I’m humbled to be in your presence. Who knew this small island has a hidden treasure such as a Grand Master.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The woman who seemed to be in her mid to late 30s, but could actually be older due to the Qi Gong she practiced, nodded. “Arcadia holds a lot of secrets that many would not even dream of.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Was that why Kingsbury was built here? ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Was that how the Kingmaker received his gifts of selection and sight? Was it tied to this island?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I knew it wasn’t a coincidence to stumble upon this shop and the Grand Master.  “If you are so kind and willing,” I said, dropping to my knees. “Could you take me on as a student? I know a bit of martial arts, but I have the desire to continue training so I could reach the level of a Master one day. My Qi Gong is just a beginner’s level, and...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Enough humbling yourself.  It doesn’t become you. It doesn’t suit your personality. You’re a girl of fire and wind. That is unique to you, so that is one of your strengths.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You have a lot of potential. Untapped,” she said, holding out my hand. “Lots of energy.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Can you teach me to reach my potential?” I asked. “I’m a fighter so this isn’t just a hobby for me. It’s my living and who I am.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She smiled. “It is good you realize this already. Yes, you are a fighter. Not a quitter. And you seem honest. There is good chi coming from you. You will not abuse your power once you reach your potential.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I hope not,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You have some power and wealth in your past. Even your present, yet you have not once used it in a dark and horrible way.” She closed her eyes for a moment and then opened them, surprising me as she said, “Yes, Tempest, I will take you on as my student.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How did you know my name?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The shop keeper laughed and said, “You’re famous. Plus, I knew of you earlier because of the kind of martial arts you practice. It is a small world amongst martial artists. I know of your teacher in San Francisco. His style is apparent in your training.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I blinked. “This meeting was meant to be.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Call me Master Lee,” she said. “Doctor Dana Lee here in the shop. I’m a practicing Eastern medicine physician and pharmacist here too.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wow, so accomplished,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Nah, for me practicing medicine goes hand in hand with training in martial arts,” Master Lee said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How did you end up on Arcadia?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“My family has been here for centuries,” she said. “We came over as pirates.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Interesting!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ll tell you about it over tea someday,” Master Lee said. “But for now. I think you might want to get going so you can use the medicine I gave you to treat your friends. And this jar here...take this once a day to boost your strength and energy. It’s bitter so take it with some honey or rock sugar in a drink.  It’s an ancient and special concoction people like yourself have been drinking for centuries.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Thank you,” I said and headed out the non-descript shop.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I made my way to the tram taking me back up the mountain to Kingsbury Prep. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("From just meeting a sample of the people in town, I could tell the island was special. The people here were special, each with their own unique family histories. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("What could have set the ones who attacked the K3s and Ricky last night? ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Why was there a resentment towards the royals that created such a mob?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Whatever it was, I needed to dispel it, break it down.  After my dream of being the Kingmaker Violet, I knew I had a history and personal connection to the castle and to this island somehow besides being a Kingsbury.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Now after meeting Master Lee, I was certain I was meant to be here.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 10")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Tempest")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I rushed into Kaz’s huge house with my packages and headed to the kitchen where the new cook Camilla, a grandmotherly woman, was preparing a meal. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Can you make a nice chicken soup with these herbs?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sure, honey,” Camilla said. “Just let me know what you’d like to eat, and I’ll make it!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Good,” I said. “This soup has some herbs that’ll help the blood circulate better and build new ones.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh good,” Camilla said. “I was beginning to worry about those boys. They need to eat healthier. They’re still growing and after their injuries, they need to get better.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ll help you plan their meals,” I said. “I think I know what they have to eat to get better, and I know what they like to eat, too.” I brought out the chocolate cake and the cupcakes.  “These are for later, but for now.  Soup first, then some of these, too.” I showed her a list of ingredients and recipes, and she nodded. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("While Camilla was preparing the meals for the guys, I went to check on each of them.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("First, I visited Ori, who was lying in the bed he slept in while staying over at Kaz’s. He was sleeping as I walked up to him and pulled down the covers, preparing to put the ointment I received from Master Lee on his gashes.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I pulled down the covers, revealing a fully naked and hard Ori.  I had to catch my breath seeing his beautiful body with its colorful tattoos of mountains, streams, and trees. His muscular and lean body with the amazing tattoo work was a work of art. He was lying on his back and I had to get to his shoulders to put on the ointment. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("There was the matter of turning him over so I could reach his back. I reached over to try to turn him over, but his arm went around me, pulling me down so my face was now on his bare chest. “So cold,” Ori shivered, still sleeping.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I tried to pull the cover over him, but he adjusted me like a blanket over his body until I was completely flushed against him. And my lower half was lined up with his. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I felt his hardness against my core. I was straddling him in this position. I could feel the heat of him on my skin. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It was intoxicating being this close to Ori and not think of all the arousing times we spent making passionate love to each other. With my nose against his chest, I could smell his manly scent of musk and cinnamon. I wanted to lick him and taste him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tempest,” I heard him whispered my name. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Was he dreaming about me or did he know I was on top of him?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I looked up daring to see his face.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He was staring down at me, his light blue eyes caressing my face. “What a nice surprise,” he said, smiling.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I was just trying to put ointment on you when you mistook me for a blanket and pulled me on top of you,” I blabbered.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ori’s lips curled up into a wicked grin. “I mistook you for a blanket? How would I do that? You’re nothing like a blanket. For one, blankets are flat, and you are definitely not flat.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I laughed. “Ori, you joker. Were you awake this entire time, but pretending to be asleep?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Partly,” he said. “I was until I felt the covers come off me. You know, I’m a trained fighter. It’s hard for me to be completely sound asleep. I sleep lightly.” He pulled me up so he could look at me face to face. His light eyes stared into mine, reminding me how handsome he was with his full lips, high cheekbones, square jawline, and white hair. The White Night. His hand reached up to touch my face. “Tempest...I can’t believe I’m touching you right now. It’s been so long.” He pulled me in for a tight hug, wrapping his arms around me while kissing my cheeks, my nose, and finally my lips. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I kissed him back, remembering how well my lips fit with his. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“God, I missed you,” he said, kissing me more passionately. “I don’t ever want to hurt you again. I don’t want to be without you again.” We kissed for a while, not wanting to break away from each other. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ori, I don’t ever want to take out my revenge on you again. Don’t ever make me punish you like that again.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He kept his eyes on mine. “Never.” Then he was kissing me like a man starving. “I swear to you, Tempest, you come first to me. I love the guys like brothers, but when it comes down to it, I’m so miserable without you. No brotherhood could take away that misery.” He kissed my eyelids, my cheeks, and my mouth again. “I’m so in love with you, it’s not even funny. I know you were behind the rumors about me taking substances for the fights.  I should be angry at you for that. You ruined my fighting career, little girl. But somehow I’m not angry at you. I care more about how I can fix what I’ve done to you than my fighting career. I care more about getting you back into my life than anything else. You can do whatever to me, and I’ll still love you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ori, you know what you and the guys did really gutted me,” I said, leaning into him. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I know, Tempest,” he said. “Biggest mistake of my life to go along with the bullying. I’m so sorry. I didn’t want to do it, but I was too much of a coward to step away from it.” He kissed my cheeks and said, “I’ll make it up to you even if it takes the rest of my life, Tempest. Just tell me what I have to do.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ori...I had my revenge on you already. I’m not vengeful and cruel.  I think you’ve learned your lesson, but I will let you know what I want from you eventually.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Okay,” Ori said. “I promise you I’ll try my best to fulfill your wish.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“For now, I want you to get better.  Turn around and let me put this on you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He did, while surprising me with a flip of his own, pining me down on the bed while he moved on top of me. The air between us suddenly became so hot as I could feel him hard against me. “Oh Tempest,” he gulped. “God, I want you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I kept staring into his eyes. “I want you too, Ori.” I closed my eyes and arched my back, getting closer to him. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He took that as a sign to go ahead, and with a groan, he tore off the buttons of my blouse, pulled the front clasp of my bra apart, letting my full breast spill into his eager hands. His thumb was immediately rubbing my nipples until they pebbled, and his hot mouth was on them, licking them, sucking on them. His mouth made their way down from my breasts to my core where he feasted on me, devouring me like he couldn’t hold back. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“God I missed your taste,” he groaned. “Tasting you is like eating ambrosia, Tempest. You’re exquisite.” He closed his eyes savoring each lick after deliberate lick. Each stroke brought me closer to climax until he plunged his fully aroused and thick dick into me, thrusting into me, riding me until we both screamed out our names as we came together. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He brought his arms around me and held me so gently afterwards, caressing my face with his, and nuzzling his nose against mine. “I love you, Tempest,” he said. “More than anything. Now I know. I didn’t deserve you before as a spoiled royal brat prince. I was too arrogant to fully appreciate you. But now having been kicked down several notches by you, I know who’s really in charge.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I smiled. “Really?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Really.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With that, I swiped open the jar of ointment and carefully spread it on each of Ori’s wounds. I got out of his bed and placed the lid back on top of the jar. “I’ll be back with food soon. Just go back to sleep and let the medicine work on you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He smiled appreciatively at me. “You don’t have to take care of me like this, Tempest. I can get a nurse...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, I want to. This is the Tempest Treatment...for only the guys who deserve to be in my harem.” I smiled sweetly. “Guess you’re back in.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ori’s face lit up with the biggest happiest smile. “Oh Tempest, that’s the best medicine I’ve ever taken.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 11")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Tempest")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")]), _vm._v(" WENT LOOKING FOR")]), _vm._v(" Ricky, wondering which room they would have stuck him in, knowing how they viewed him as the outsider, the commoner like me, and worse...the ordinary guy who stole me from them. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Knowing they wouldn’t have given him a regular bedroom, I went to the room they had fixed up for my playroom, the California room, which the K3s had fixed up to look like the interior of the silver Gulfstream trailer I lived in with my little sister Lily. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Bright California beach colors filled the room, along with picture postcards of the beach, sunsets, ice cream. Fun colors. Fun themes. I had loved that room, which was a birthday surprise for me from the K3s. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I opened the door and was greeted with a hand grabbing my shirt, pulling me in and pinning me to the wall. Immediately, I fought back, grabbing the palm of the hand, and twisting the thumb so he would let go.  Keeping a hold on the hand, I twisted it along with the arm to loop painfully behind my attacker, pushing it up until he was crying out, “Please let go. I give up.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ricky?” I cried out.  “What the hell?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I thought you were one of the guys or their servants,” he said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Why would you be trying to fight them?  Weren’t you all attacked by the townspeople together? Why are you on defensive with them?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well, they wanted to kidnap me before the stoning happened. To ask questions about you, I could only guess. The townspeople going down from Kingsbury back to their homes in town saw them and began calling names. The townspeople saw the K3s forcing me to go with them so that’s when the mob attack against Kingsbury started.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Because they saw you being kidnapped by the K3s?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, that was why,” Ricky said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So, did the K3s get to ask you anything?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, we were attacked by the townspeople before they can, but now I’ve been stuck with them all this time, even being moved to stay in this place.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kaz’s house,” I said. “And this room...it’s the room they fixed up for me as my birthday surprise. It was really sweet.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ricky looked around. “They did all this for you? With their own hands?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yup, they know how much I value things when they make it themselves. They could have just snapped their fingers to get other people to do it, but instead, they did this for me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ricky blew a whistle. “They really did care for you. The details, the craftsmanship. Someone put a lot of love into building you your special little haven.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kaz, Ori, and Hunter,” I said. “That’s who. Stepping in here just reminded me of that.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ricky put his arms around me then, pulling me close to him. He kissed me and said, “A lot of people love you, Tempest. It makes me feel more secure knowing you are so well-loved. I’m jealous of the K3s of course, but I’d rather they love you than hate you like before.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So you’re so benevolent, aren’t you? Ready to share me with the Princes, are you?” I asked, putting my finger up against his hard chest. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He pulled me close and nibbled on my ear, growling, “I’d rather have you all to myself. You know that, Tempest, don’t you or should I remind you?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He lifted me and gently placed me on the leather sectional in the middle of the room before kneeling down and running his hands up my inner thighs. His fingers reached underneath my panties to twirl and rub against my nub, driving me insane with need. “Oh Ricky, just fuck me now.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Don’t you want more foreplay, honey?” he asked, licking his lips. “I want to eat you so badly.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, if you must,” I huffed. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He bent down and as his hot wet tongue touched me, I jumped. His mouth was on me, licking me and biting me, pushing against me so I wanted so much more of him. “I want you in me now,” I panted.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He stood up, unzipped his jeans, and let his massive dick out. He was by far the largest most well-endowed of all my guys. “Want this?” he asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What do you think?” I fired back. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Damn yes,” I moaned in frustration as his fingers built me up to near climax.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He rammed into me, sending me into a frenzy, and kept thrusting until he was exploding with me.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I wrapped my arms around his neck and kissed him, still trying to catch my breath. “I can’t get enough of your hidden talents,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He kissed me hungrily and said, “I can’t get enough of you.” He put his forehead against mine after he pulled slightly back and said, “Want me to stay here with you or do you want me to go back into town. I’ve recovered enough where I think I can walk back. Still sore, but...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Stay,” I said. “You’re getting the Tempest Treatment,” I started rubbing his cuts and bruises with the ointment. “You’re part of my harem after all.”")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 12")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Tempest")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")]), _vm._v(" WALKED INTO THE ROOM")]), _vm._v(" Hunter always stayed in when he was at Kaz’s. I didn’t find him in bed, and was about to walk out of his room, when a warm hand touched my arm.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I turned around to find Hunter standing right next to me, his hair wet, and his body clad only with a towel around his waist. “Hunter,” I said breathlessly. I could feel the warmth of his freshly-showered body heating me up. Even with gashes on his shoulders and back, he was one of the most gorgeous man I’ve ever seen. His chocolate brown eyes devoured me from head to toe. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tempest,” he barely whispered. He was staring at me like he couldn’t believe his eyes. “What are you doing here?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I came to put some ointment on you, to take care of you,” I said, barely above a whisper. I swallowed. Hunter was like sex on legs. I couldn’t think as he grabbed my waist and pulled me into him in a tight embrace. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How very sweet of you, Tempest,” he said, resting his chin on top of my head. “But I have to get going.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Why?” I asked. I wrapped my arms around his back and was patting him when he winced. “Are you okay?” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I still have some cuts on my back,” he said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Then why don’t you stay and rest so you can heal? Where are you rushing off to?  A concert? An art gallery opening?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Hunter smiled sadly at me. “I wished that was where I’m going. Unfortunately, being accused of sexually harassing Veronica and Sabrina, which is completely false, got me expelled. I can’t believe they accused me of it when they were the ones sexually harassing me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So you’re really going to leave school?” I asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Even Kaz couldn’t reverse it. And this is his school.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My heart sank remembering how I had caused Hunter’s expulsion from Kingsbury Prep as part of my revenge plans. “You have to leave today?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“By midnight,” Hunter said. “My stuff’s all packed and loaded into a jet my parents sent over.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh Hunter,” I kissed his cheeks. “You can’t go. We’ll find a way for you to stay.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Hunter held me tighter. “When we broke up and you didn’t even look at me afterwards, I stopped caring about being in Kingsbury Prep. I stopped caring about being part of the K3s. All I knew was that you were the most important person in the world to me. And I had lost you.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He kissed me so passionately, I was swept off my feet. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I want to make love to you right here, right now, Tempest,” Hunter said, “but I won’t.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hunter,” I said. “I’m sorry. I was part of it all.  Your expulsion. I can get you reinstated.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Hunter stared at me. Was he angry? Would he forgive me? ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It looked like he was thinking...trying to come up with a decision or something.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He let go of me and walked away. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hunter?” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("His back was to me, and I could see it covered with gashes that were still healing. My heart fell seeing his beautiful body beaten up, cut up by stones. Hunter, my Prince. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He was shaking and his fists were clenched tight against his body. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hunter?” I said. “You’re not leaving Kingsbury. You haven’t been expelled. It was all part of my revenge plans to make you think you were. It never happened.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Hunter turned towards me, and I expected to see hate in his eyes for me, or at least anger. But instead, I found him laughing, laughing so hard he was bent over, clutching his stomach. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I should have known that was you on the phone. Your voice was disguised, but it was you pretending to be an administrator at Kingsbury. God, I fell for it. You got me really good, Tempest. Clever. So clever. You tricked me into believing I was expelled. Then I told Kaz I was expelled, you knew it would force him to break off his engagement to Veronica.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I clapped my hands and said, “You got it. That’s how it played out. So you see, Hunter, you weren’t really expelled.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And that was you on the phone acting like a representative of a bank, telling me I lost everything in my checking account. Well, not everything, but a significant amount.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“My God, Tempest, you’re so convincing, you should be an actress.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Maybe I should,” I said. “And maybe you and Kaz should be actors, too.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Hunter stopped laughing and asked, “What do you mean?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Only that you had me believing you guys in San Francisco that Kingsbury Prep was probably just a dream.”  I started laughing. “Would that be funny that I dreamt all this up, and you guys really were just a figment of my imagination.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That would be funny, wouldn’t it?” Hunter said. “About that...I’m sorry to fuck with your mind like that. It was wrong, and I wished it never happened. Lying to you and messing with you like that...I hated myself for doing it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So, Hunter, are we even?” I asked. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He shook his head “no”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No?” I asked. “Why?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We are not even,” Hunter said. “I forgive you for acting out your revenge on me, but I still owe you, Tempest. I owe you whatever you want.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I sighed and said, “Well then. For my first wish, I’d like you to turn around.” I applied the ointment on all his injuries and said, “Hunter, I want you back in my harem.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Hunter’s eyes lit up and he said, “Anything to keep having you in my life, Tempest. I’ll accept whatever role I must play to have you.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 13")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Tempest")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")]), _vm._v(" WAS ABOUT TO GO INTO")]), _vm._v(" Kaz’s bedroom when Gerard the Butler found me and said, “Chef Camilla has prepared the meal as you instructed her. Shall I retrieve the boys, or should it be served to each of them in their own rooms?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I smiled. “Good. How about serving it at our usual breakfast table. The ones not able to get out of bed will be served their meals by their bedside. I’ll feed them then.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Gerard nodded. “A wise decision, Ms. Ryan.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Gerard walked off and I made my way to Kaz’s bedroom, down the hall that I’ve walked through hundreds of times, always feeling such love and passion when I thought of Kaz and what I’d find when I’d reached him. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kaz...who had loved me so much he protected me from his own decree of the Black Envelope. Kaz who would steal me away in between classes to take me back to his bedroom to have hot passionate sex. Then Kaz who instigated the next phase of bullying for something I didn’t know I did. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My emotions were mixed but strong when it came to Kaz.  The other guys in K3 didn’t hate me like Kaz did. Ori and Hunter never wanted to hurt me. They never hated me and wanted me gone from Kingsbury as Kaz did. It was easy to forgive them after I’ve had my revenge on them and had taught them a lesson.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It was easy to take Ori and Hunter back into my harem. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But Kaz...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I walked into Kaz’s bedroom, expecting to see Kaz still in bed, his head bandaged up because of a concussion. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But as I walked into Kaz’s bedroom, I felt something was off.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hi Tempest,” a familiar voice said. “I thought I’d find you here.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jordan stepped forward out of the shadows of darkness in the room and came over to me, enveloping me into his arms. “Baby, I missed you.” He kissed me softly at first and then more passionately, while his hands went down to reach underneath my school uniform skirt to pull aside the crotch of my panties to rub my clit. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Jordan,” I panted, feeling my body building up to a climax. “What are you doing here?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I couldn’t find you in San Francisco where I left you. When I went back to my suite, you were gone. I went to Helen’s to ask where you went, and she didn’t even know. You had me worried at first, Tempest. You just vanished.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sorry that I made you worried,” I said. “I heard that the kids at Kingsbury were attacked so I headed out here as soon as I could.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jordan stopped kissing me and said, “My beautiful sexy Tempest. Always worrying about others and never fussing over your own beautiful self.”  He lifted me and brought me over to Kaz’s bed, placing me on top of it before reaching down to pull my panties off.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He immediately went down on me, his mouth attacking my folds, his tongue fucking into me, causing me to moan. “Oh my God, Jordan,” I purred, my hands fisting his gorgeous thick black hair. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Having you in my arms, having you before me, eating you, claiming you as mine...was definitely worth the trip here,” Jordan smiled at me, while still eating me. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Jordan...” I began convulsing. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He stood up, unzipped his slacks to release his hard dick before plunging into me, thrusting until we both let out a loud groan and climax together. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I was settling down from my orgasm when I opened my eyes and saw a figure standing by the bed, looking down at us.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kaz. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Where was he all this time?  Why didn’t I bother trying to find him when I first entered his bedroom? Instead I found Jordan, who immediately made me forget why I was in Kaz’s bedroom. What was wrong with me?  Did I really feel so passionate about Jordan that I would forget Kaz?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kaz?” I whispered. “Where were you? I was looking for you when...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He was staring at me with such hate in his eyes. And such pain.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tempest...” he said. “I didn’t want to believe it at first. That you were with Jordan, but now I have to believe it. You’re right here with him in my bedroom, fucking him!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kaz,” Jordan said. “I was waiting for you, but you were locked in your bathroom for a while.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Why the fuck are you here?” Kaz asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“To rescue you! To check on you,” Jordan said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Fuck!  Like this? Fucking my girl? Or is she your girl?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Kaz!” I cried out. “I can explain.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He was already out the door as I ran out.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 14")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Hunter")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-k"
  }, [_vm._v("K")]), _vm._v("AZ APPEARED OUT OF")]), _vm._v(" nowhere in the hallway and pulled me aside just as Ori walked towards me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“In your room now!” he said leading us into my bedroom.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Jordan and Tempest. It’s bad. She is with him.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“She’s with him now?” Ori asked, his face in disbelief.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kaz’s face was ashen. Pale as a ghost. “Shit, I’m in hell. I can’t believe she would do this to me. Why, Tempest? This is the worse thing you could do to me other than stabbing me right in the back for real.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You know Tempest...we’re not the only ones in her harem of guys...we’ve accepted that...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But it’s Jordan,” Kaz said. “Fucking asshole Jordan!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I agree, Ori, if it was anyone else, it’s forgivable, but it’s with Jordan. Do you know the significance of that?  How big of an impact that is?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ori closed his eyes and nodded. Then he let out a loud roar as loud as Kaz’s. “Fuck!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It means Kaz loses his kingdom. He no longer will become king of his country when he was already the crown heir,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kaz sat down and laid his head in his hands. “I was so fucking stupid!  I thought my parents wouldn’t approve of Tempest. I thought they wanted me to marry someone of royal blood, but it turns out the blood of a kingmaker trumps anyone with royal blood. Tempest is the prize. She’s the one I should be with. She’s the one I’d give anything to be with. But I assumed my parents wouldn’t even consider her because she was a commoner. I was so wrong. I was so stupid. I didn’t even bring it up to them that I wanted Tempest. Instead I gave them the choice. Instead of choosing on my own girl, by not choosing, they chose for me, and it turned out to be that bitch Veronica.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Now Jordan has her, and he has the approval of your father,” I said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So Jordan will become King,” Ori said. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And he hates anything royal...so what will become of Kingsbury Prep...the school for royals?” Kaz asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“He’ll shut it down,” we all said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Tempest and her friends will return in the next Kingsbury Prep Book:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Reign of Rebels (Feb. 7, 2020)")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "text-align": "center",
      "text-decoration": "underline",
      "text-indent": "0"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.amazon.com/dp/B07XM3FKW6",
      "target": "_blank"
    }
  }, [_vm._v("https://www.amazon.com/dp/B07XM3FKW6")])]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Kingmaker’s Kings (Kingmakers of Kingsbury #1)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("(Feb. 3, 2020)")]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-size": "large",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.amazon.com/dp/B082QMNCW4",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-h"
  }, [_vm._v("H")]), _vm._v("TTPS://WWW.AMAZON")]), _vm._v(".com/dp/B082QMNCW4")])]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Will Feature Violet, Prince Axel, Prince Avery, and Tempest")]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-size": "small"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-l"
  }, [_vm._v("L")]), _vm._v("ONG BEFORE THERE WAS")]), _vm._v(" an All-Royals Academy called Kingsbury Prep, there was the Kingmaker and her kings. ")]), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Violet Kingsbury was born to be a kingmaker. ")]), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("In a time when wars were common and thrones were fought after,")]), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("the only name that could bring about peace...the only man that could trump the decrees of kings was Kingsbury. The Kingmaker.")]), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("But when the legendary Kingmaker is disposed, and the time of the Choosing has come, can the daughter of The Kingmaker rise to take the place of her father?")]), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("She is about to find out as the strongest, most capable, and most legendary princes across the lands come to challenge her for the Choosing. ")]), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Becoming Kingmaker, even as The Kingmaker's daughter, will not be easy in a male world where ladies were supposed to be damsels who needed saving.")]), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("To become Kingmaker, Violet will prove to all, especially the princes, that she's here to stay, and will be the one doing the saving.")]), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("**Kingmaker's Kings is the first book in the Kingmakers of Kingsbury Series, a Reverse Harem Bully Romance with mixed genres elements, action, and mature scenes recommended for age 17 and up.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ca73a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c004.vue
// module id = 69
// module chunks = 0